<div class="page-container">
  <div class="navigation-bar-container">
    <app-header></app-header>
  </div>

  <div class="home-page-header-container">

    <div class="home-page-header-center-area">
      <div class="home-page-header-text">Ker si vsi zaslužijo<span class="home-page-header-text-bold"> enake možnosti in zdrav razvoj</span>
      </div>

      <div class="home-page-search-bar" (mouseleave)="onSearchLeave()">
        <div>
          <div class="search-icon" (click)="onSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16"><title>
              search</title>
              <g fill="#565656">
                <path fill="#565656"
                      d="M7,14c-3.86,0-7-3.14-7-7s3.14-7,7-7s7,3.14,7,7S10.86,14,7,14z M7,2C4.243,2,2,4.243,2,7s2.243,5,5,5 s5-2.243,5-5S9.757,2,7,2z"></path>
                <path
                  d="M15.707,14.293L13.314,11.9c-0.411,0.529-0.885,1.003-1.414,1.414l2.393,2.393 C14.488,15.902,14.744,16,15,16s0.512-0.098,0.707-0.293C16.098,15.316,16.098,14.684,15.707,14.293z"></path>
              </g>
            </svg>
          </div>
          <input (click)="onSearchFocus()" (focus)="onSearchFocus()" (blur)="onSearchBlur()"
                 [(ngModel)]="searchTerm"
                 (keyup)="onSearchKeyUp()"
                 (keyup.enter)="onSearch()"
                 placeholder="Išči pojem ali brskaj kategorije..."
                 class="home-page-header-search-input">
        </div>
        <div class="home-page-search-suggestions" *ngIf="searchSelected">
          <div class="home-page-search-suggestions-title">Brskanje po kategorijah</div>
          <div *ngFor="let category of categories" (mousedown)="onCategory(category)" class="home-page-search-suggestion-item">{{category.name}}
<!--            ({{category.count}})-->
          </div>
        </div>
      </div>

    </div>

    <div class="home-page-bottom-cta-container">
      <div class="home-page-cta-item-container">
        <div class="home-page-cta-item" routerLink="/nasveti">
          <div class="home-page-cta-item-icon home-page-cta-item-icon-advice"></div>
          <div class="home-page-cta-item-text">Koristni nasveti</div>
        </div>
      </div>

      <div class="home-page-cta-item-container">
        <div class="home-page-cta-item" routerLink="/aktivnosti">
          <div class="home-page-cta-item-icon home-page-cta-item-icon-workshops"></div>
          <div class="home-page-cta-item-text">Aktivnosti in delavnice</div>
        </div>
      </div>

      <div class="home-page-cta-item-container">
        <div class="home-page-cta-item" routerLink="/svetovalnica">
          <div class="home-page-cta-item-icon home-page-cta-item-icon-consultations"></div>
          <div class="home-page-cta-item-text">Svetovalnica</div>
        </div>
      </div>
    </div>
  </div>

  <div class="featured-items-section-container">

    <div class="featured-items-title">
      <div class="featured-items-title-left-border"></div>
      <div class="featured-items-title-text" routerLink="/nasveti">Zadnji nasveti</div>
    </div>

    <div class="featured-items-container">

      <div class="featured-item-container" *ngFor="let article of articles">
        <div class="featured-item-inner-container" routerLink="/nasvet/{{article._id}}">
          <div class="featured-item-header-image" *ngIf="article.image"
               [style.background-image]="'url('+serverUrl+'/'+article.image.url+')'"></div>
          <div class="featured-item-content-container">
            <div class="featured-item-header-date">{{formatDate(article.publishDate)}}</div>
            <div class="featured-item-header-title">{{article.title}}</div>
            <div class="featured-item-header-excerpt">{{getArticleTextString(article)}}</div>
            <div class="featured-item-header-more">
              <app-button text="Več"></app-button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="featured-items-section-container">

    <div class="featured-items-title">
      <div class="featured-items-title-left-border"></div>
      <div class="featured-items-title-text" routerLink="/aktivnosti">Aktivnosti</div>
    </div>

    <div class="featured-items-container">

      <div class="featured-item-container" *ngFor="let event of events">
        <div class="featured-item-inner-container" routerLink="/aktivnost/{{event._id}}">
          <div class="featured-item-header-image" *ngIf="event.image"
               [style.background-image]="'url('+serverUrl+'/'+event.image.url+')'"></div>
          <div class="featured-item-content-container">
            <div class="featured-item-header-title">{{event.title}}</div>
            <div class="featured-item-header-label featured-item-header-label-1">
              <b>Kdaj:</b> {{formatDateAndTime(event.startsAt)}}</div>
            <div class="featured-item-header-label"><b>Kje:</b> {{event.address}}</div>
            <div class="featured-item-header-excerpt">{{getEventTextString(event)}}</div>
            <div class="featured-item-header-more">
              <app-button text="Več"></app-button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="sponsors-section-container">
    <div class="sponsors-section-title">Frido omogočata</div>
    <div class="sponsors-section-orange-bar"></div>
    <div class="sponsors-logo-container">
      <img src="/assets/images/zpm_logo.png" height="60px">
      <img src="/assets/images/generali_logo.png" class="generali-logo" height="60px">
    </div>
  </div>

  <div class="page-footer">
    <div class="left-footer">ZPM Moste Polje - Frida</div>
    <div class="right-footer" routerLink="/admin/nasveti">Prijava</div>
  </div>

</div>
